// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"ac196ea0","39":"9ef13bb9","274":"356c7560","308":"764a91ee","353":"7b85619c","428":"cf9ba7bd","448":"9edc409e","449":"a678088a","488":"a578a896","584":"67209c85","598":"680b4f50","614":"ca433243","753":"263a37de","806":"75e71753","910":"938c9065","961":"59251b85"}[chunkId] + ".chunk.js";
};